/* eslint-disable max-len */
import moment from 'moment';
import React, { useContext, useState } from 'react';
import UpdateButton from '../../../../../components/UpdateButton';
import AnimatedModel from '../../../../../components/Animation/AnimatedModel';
import ConfirmationPrompt from '../../../../../components/ConfirmationPrompt';
import GlobalContext from '../../../../../components/Context/GloablContext';
import { dataService } from '../../../../../services/data.services';
import { useNavigate, useParams } from 'react-router-dom';
import AnimatedButton from '../../../../../components/Animation/AnimatedButton';
import DescriptionModal from '../../../../../components/DescriptionModal';
import { ConvertToTitleCase } from '../../../../../CommonMethods/ConvertToTitleCase';
import { handleEndpoint, handleName } from '../../../../../CommonMethods/Keyshandler';
import FromatDateString from '../../../../../CommonMethods/FromatDateString';

const TableBody = ({tableData, indexNum, setActivateOpen, selectedIndex,email, setSelectedIndex, selectedRef, lastIndex ,type,editOpen,setEditOpen,editData, setEditData,getBranch
    
}) => {
    /**
     * This function sets the confirmation state to activate or deactivate an item in a table.
     */
    const navigate = useNavigate()
    const {setToastErrorMessage, setToastmessage, isInactiveBranch} = useContext(GlobalContext);
    const [activateButtonLoading, setActivateButtonLoading] = useState(false)
    const [isActiveOpen, setIsActiveOpen] = useState(false)
    const handleActivateOpen = () => {
        setActivateOpen(true)
        setIsActiveOpen(true)
    }
    const [descriptionModal,setDescriptionModal] = useState(false);
    // const [editOpen, setEditOpen] = useState(false)
    const handleOnCLickActivate = async () => {
        setActivateButtonLoading(true);
        try {
            let body = {
                "status": !tableData.status,
            }
            let endpoint= `${handleEndpoint(type)}/${tableData._id}`
            const response = await dataService.PatchAPI(body,endpoint);
            handleConformationClick();
            setActivateButtonLoading(false);
            setToastmessage(`${ConvertToTitleCase(handleName(type))} ${!tableData.status ? 'activated' : 'deactivated'} successfully`);
            getBranch('no')

        } catch (error) {
            handleConformationClick();
            setActivateButtonLoading(false);
            setToastErrorMessage(error?.response?.data?.message || "Something went wrong")
            console.error(error);
        }    }
    const handleConformationClick = () => {
        setSelectedIndex(null)
        setActivateOpen(false)
        setIsActiveOpen(false)
    }
    const handelActionButton = async(e,indexNum) =>{
        e.preventDefault()
        setSelectedIndex(indexNum)
    }
    return (
        <>
            <tr id= "list-items" aria-colspan="7" className="h-0.5"></tr>
            <>
                <tr class={`${selectedIndex === indexNum  ? 'pb-[100px]' : ''} ${tableData?.status?'':'inactive'}`}>
                    <td class="text-start">
                        {tableData?.name}
                    </td>
                    {type === 'subjects' && <td class="text-start">{tableData?.is_optional ? 'Optional' : "Mandatory"}</td>}
                    <td class="text-start">{FromatDateString(tableData?.created_at)}</td>
                    <td class="text-start ">
                        {tableData?.created_by}
                    </td>
                    <td class="text-start">{FromatDateString(tableData?.updated_at)}</td>
                    <td class="text-start ">
                        {tableData?.updated_by}
                    </td>
                    <td class="table-cell">
                        <div className='flex justify-start'>
                            <div class={`w-fit rounded ${tableData?.status ? 'bg-[#C5FFD5]' : 'bg-[#B3BBC1]'} flex items-center justify-center py-1 px-2.5`}>
                                <img loading="lazy" decoding="async"src={tableData?.status ? "/images/successDot.svg" : "/images/inactive-Dot.svg" } alt="icon"/>
                                <span class="text-f7 font-normal text-[#031624] pl-1">{tableData?.status ? 'Active' : 'Inactive'}</span>
                            </div>
                        </div>
                    </td>
                    <td class={`text-start `}>
                        <div class="relative flex items-center justify-center" data-te-dropdown-position="dropstart">
                            <button 
                                id={tableData?.email_address}
                                onClick={(e) =>handelActionButton(e, indexNum) }
                                disabled={isInactiveBranch}
                                className={`list-more-btn prevent-click ${isInactiveBranch?"img-disable":""}`} href="#" type="button"
                                data-te-dropdown-toggle-ref="" aria-expanded="false" data-te-ripple-init="" data-te-ripple-color="light">
                                {!editOpen && <img loading="lazy" decoding="async" src="/images/listAction.svg" alt="icon" class="w-[6px] h-[25px]"/>}
                            </button>
                            {selectedIndex === indexNum && !isInactiveBranch && <ul ref={selectedRef} class={`${(indexNum+1 === 10 || indexNum+2 === 10) ? (tableData?.status?"top3":"top1") : ''} list-more-optns-div [&amp;[data-te-dropdown-show]]:block`} aria-labelledby="dropdownMenuButton2" data-te-dropdown-menu-ref="">
                                {tableData?.status && <li>
                                    <AnimatedButton 
                                        handleClick={() => {
                                            setEditData(tableData)
                                            setSelectedIndex(null);
                                            setEditOpen(true);
                                        }} 
                                        buttonName={`Edit ${handleName(type)}`}
                                        className="list-more-optns prevent-click"/>
                                </li>}
                                <li>
                                    <AnimatedButton 
                                        handleClick={handleActivateOpen} 
                                        buttonName={tableData.status ? "Deactivate" : "Activate"}
                                        className="list-more-optns prevent-click"/>
                                </li>
                            </ul>}
                        </div>
                    </td>
                </tr>
                
            </>
            {isActiveOpen && 
            <AnimatedModel
                Children={
                    <ConfirmationPrompt
                        handleOnCLickActivate={handleOnCLickActivate}
                        handleClose={handleConformationClick}
                        tittle= {`${!tableData.status ? 'Activate' : 'Deactivate'} ${handleName(type)}`}
                        message = {`Are you sure you want to ${!tableData.status ? 'activate' : 'deactivate'} the ${handleName(type)} '${tableData.name}' ?`}
                        buttonName = {`${!tableData.status ? 'Activate' : 'Deactivate'}`}
                        loadingActivation={activateButtonLoading}
                    />
                }
            />  
            }
            {descriptionModal && 
                <DescriptionModal 
                    descriptionModal={descriptionModal}
                    setDescriptionModal={setDescriptionModal}
                    description={tableData.description}
                />
            }
            {/* {editOpen && <EditClass
                sideModelType={ConvertToTitleCase(handleName())}
                handleSidePopupClick={() => setEditOpen(false)}
                setInputValue={setEditData}
                type={type}
                inputValue={editData}
                handleName={handleName}
            />} */}
        </>
    );
}

export default TableBody;
